module.exports = __webpack_public_path__ + "static/img/ninjatown_port_lg.40bf1ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/ninjatown-banner-campaign/ninjatown_port_lg.jpg
// module id = 265
// module chunks = 2